module.exports = "<div class=gmw-main-table__body-row ng-transclude></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/main-table-body-row/main-table-body-row.html
// module id = 281
// module chunks = 0